import React, { useState, useEffect } from 'react';
import { Password } from 'primereact/password';

const ResetPassword = ({ onPasswordChange }) => {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errors, setErrors] = useState({});

    const validate = () => {
        const err = {};
        if (!newPassword) {
            err.newPassword = 'Password is required';
        }

        if (!confirmPassword) {
            err.confirmPassword = 'Please confirm your password';
        } else if (newPassword !== confirmPassword) {
            err.confirmPassword = 'Passwords do not match';
        }
        setErrors(err);
        return Object.keys(err).length === 0;
    };

    useEffect(() => {
        if (onPasswordChange && validate()) {
            onPasswordChange(newPassword);
        }
    }, [newPassword, confirmPassword]);

    return (
        <div className="p-d-flex p-flex-column p-jc-between">
            <div className="p-col-12 p-md-4 p-pt-2">
                <div className="">
                    <label htmlFor="newPassword" >New Password<span style={{ color: "red" }}>*</span></label>
                    <Password
                        id="newPassword"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        toggleMask
                        feedback={false}
                        maxLength={20}
                        className="p-mt-2 p-w-100"
                    />
                    <span className="error-msg" style={{ color: 'red' }}>
                        {errors.newPassword ? errors.newPassword : null}
                    </span>
                </div>
            </div>

            <div className="p-col-12 p-md-4 p-pt-2">
                <div className="">
                    <label htmlFor="confirmPassword">Confirm Password<span style={{ color: "red" }}>*</span></label>
                    <Password
                        id="confirmPassword"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        toggleMask
                        feedback={false}
                        maxLength={20}
                        className="p-mt-2 p-w-100"
                    />
                    <span className="error-msg" style={{ color: 'red' }}>
                        {errors.confirmPassword ? errors.confirmPassword : null}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
